import { FC } from 'react';

import { Chip, ChipProps, useTheme } from '@mui/material';

interface UnreadCountBadgeProps extends ChipProps {
  channel?: string;
}

const UnreadCountBadge: FC<UnreadCountBadgeProps> = ({ channel, ...props }) => {
  const theme = useTheme();

  let backgroundColor: string;
  if (!channel || channel === 'team') {
    backgroundColor = theme.palette.accent.main;
  } else if (channel === 'location') {
    backgroundColor = theme.palette.purple[500];
  } else if (channel.startsWith('service')) {
    backgroundColor = theme.palette.blue[500];
  } else if (channel.includes('advertiser')) {
    backgroundColor = theme.palette.magenta[500];
  } else {
    backgroundColor = theme.palette.accent.main;
  }

  return (
    <Chip
      style={{ backgroundColor }}
      sx={{
        minWidth: '21px',
        height: '16px',
        borderRadius: '26px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 !important',
        '& .MuiChip-label': {
          padding: '0 6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#FFF',
          fontFamily: '"Neue Frutiger World", sans-serif',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '160%',
        },
      }}
      {...props}
    />
  );
};

export default UnreadCountBadge;
